import {
  EyeInvisibleOutlined,
  EyeOutlined,
  FileMarkdownFilled,
  FileMarkdownOutlined,
  LinkOutlined,
} from '@ant-design/icons'
import { Tooltip } from 'antd'
import cls from 'classnames'
import { isNumber } from 'lodash'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { PostType } from '@/generated/graphql'

import s from './post-editor.module.less'
import { PostEditorSetState, PostEditorState } from './post-editor.state'

interface PostEditorActionsProps {
  state: PostEditorState
  setState: PostEditorSetState
  groupId?: number
  isEdit?: boolean
  anonymousCount?: number
  hideAnonymous: boolean | undefined
  uploadClickRef: React.RefObject<HTMLElement>
}

export const PostEditorActions: React.FC<PostEditorActionsProps> = ({
  state,
  setState,
  hideAnonymous,
  anonymousCount,
  uploadClickRef,
}) => {
  const [t] = useTranslation()

  const MarkdownIcon = state.isMarkdown ? FileMarkdownFilled : FileMarkdownOutlined
  const AnonIcon = state.isAnonymous ? EyeInvisibleOutlined : EyeOutlined

  const isAnonAvailable = isNumber(anonymousCount) && anonymousCount > 0

  return (
    <div className={s.actionsContainer}>
      {state.postType !== PostType.Forum && (
        <Tooltip title={state.isMarkdown ? t('post.editor.isMarkdown') : t('post.editor.markdown')}>
          <MarkdownIcon
            className={cls(s.markdownButton, { 'is-active': state.isMarkdown })}
            {...(state.postType !== PostType.Journal && {
              onClick: () => setState((state) => ({ ...state!, isMarkdown: !state!.isMarkdown })),
            })}
          />
        </Tooltip>
      )}

      {state.postType !== PostType.Forum && (
        <Tooltip title={t('post.editor.upload')}>
          <LinkOutlined ref={uploadClickRef} />
        </Tooltip>
      )}

      {!hideAnonymous && (
        <Tooltip
          title={
            isAnonAvailable
              ? state.isAnonymous
                ? t('post.editor.disableAnon')
                : t('post.editor.anonymousCount') + anonymousCount
              : t('post.editor.anonymousCountIsZero')
          }
        >
          <AnonIcon
            style={{ cursor: isAnonAvailable ? 'pointer' : 'not-allowed' }}
            className={cls(s.anonButton, { 'is-active': state.isAnonymous, disabled: !isAnonAvailable })}
            onClick={() => isAnonAvailable && setState((state) => ({ ...state!, isAnonymous: !state!.isAnonymous }))}
          />
        </Tooltip>
      )}
    </div>
  )
}
